import React from "react";
import "../style/BaseInfo.css";
import RadioButton from "./RadioButton";

const HamburgerInfo = (props) => {
  let theme= props.formData.base_carne;

  const onChangeTheme = (e) => {
    const { id } = e.target;
    const pos = props.baseCarne.findIndex((p) => p.id_ingredienti == id);

    theme.forEach((element, index) => {

      if (pos === index) {
        theme[index] = true;
      } else {
        theme[index] = false;
      }
    });

    props.setFormData({
      ...props.formData,
      totale: Number(props.formData.totale)+ Number(props.baseCarne[pos].prezzo),
      base_carne: theme,
      carne: e.target.value,

    });



  };

  return (
    <div className="baseinfo-container">
      
      {props.baseCarne.map((item, index) => {
        

          return (
            <RadioButton
              key={index}
              id={item.id_ingredienti}
              value={item.nome}
              prezzo={item.prezzo}
              text={item.nome}
              onChange={onChangeTheme}
              checked={theme[index]}
            />
          );
        
      })}
    </div>
  );
};

export default HamburgerInfo;
